export default __webpack_public_path__ + "static/media/nodejs.d9f098c7.png";